<template>
  <div style="height: 100%;">
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import List from './events/List'
import Editor from './events/Editor'
import BottomSheet from './BottomSheet'

export default {
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/events/list'
    },
    {
      path: "new",
      name: "New event",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        edit: "Edit event"
      }
    },
    {
      path: "edit/:id",
      name: "Edit event",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        new: "New event"
      }
    },
    {
      path: "list",
      name: "Event list",
      component: List
    }
  ],
  data () {
    return {
    }
  }
}
</script>
<style>
.el-loading-mask.error, .el-loading-text {
  color: red !important;
}
.el-loading-mask.error .circular {
  display: none;
}
.el-loading-mask.error .el-loading-spinner:before {
  content: "\f071";
    font-family: FontAwesome;
    font-style: normal;
    font-weight: normal;
    text-decoration: inherit;
    color: #000;
    font-size: 42px;
    color: red;
}
</style>
<style scoped>
.events-content {
  margin-top: 10px;
}
.event {
}
</style>
